import type { UseQueryResult } from "@tanstack/react-query"
import { useQuery } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { retrySolarSetupRead } from "./solar-read-retry"
import type { SolarProposalAddersDto } from "../dto/solar-proposal-pricing-steps.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/** The seller-visible adders with each one's saved state and input mode. */
export default function useSolarProposalAdders(
  proposalId: string | undefined,
): UseQueryResult<SolarProposalAddersDto, unknown> {
  return useQuery({
    queryKey: queryKeys.solarProposal.adders(proposalId ?? ``),
    queryFn: () => solarProposalService.getAdders(proposalId ?? ``),
    enabled: Boolean(proposalId),
    retry: retrySolarSetupRead,
  })
}
